import React from "react";
import { ExternalLinkIcon } from "@heroicons/react/solid";
import Modal from "./Modal";

function Project({
	project: {
		image,
		title,
		subtitle,
		descriptionView,
		description,
		link,
		gitlink,
		skills,
		roles,
		highlights,
		images,
	},
}) {
	const [showModal, setShowModal] = React.useState(false);

	const ImageLoader = (image) => {
		return (
			<img
				className='md:w-1/3 h-400 md:border-r-2 md:border-gray-700 w-full md:h-auto md:rounded-r-none md:rounded-l-xl rounded-t-xl rounded-b-none'
				src={image}
				alt=''
				width='384'
				height='512'
			/>
		);
	};

	return (
		<React.Fragment>
			<figure
				onClick={() => setShowModal(true)}
				className='border-2 border-gray-700 cursor-pointer transform-none md:transform-gpu hover:-translate-y-1 ease-in-out duration-300 md:flex flex-auto bg-gray-800 rounded-xl md:p-0'
			>
				{ImageLoader(image)}
				<div className='p-5 md:pt-6 md:pb-4 text-left space-y-4'>
					<p className='text-lg text-yellow-500 font-semibold word-break'>
						{title}
					</p>
					<figcaption>
						<div className='text-gray-400 text-sm md:text-md font-semibold -mt-3'>
							{subtitle}
						</div>
						<div className='text-gray-400 text-sm md:text-md mt-4 word-break'>
							{splitter(descriptionView)}
						</div>
					</figcaption>
					<div className={`${gitlink ? "space-x-2" : "space-x-0"} flex`}>
						<a
							className={`${!gitlink && "hidden"}`}
							href={gitlink}
							target='__blank'
						>
							<svg
								className='inline-flex w-5 h-5 text-gray-400 hover:text-gray-500'
								xmlns='http://www.w3.org/2000/svg'
								viewBox='0 0 24 24'
							>
								<path
									fill='currentColor'
									d='M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z'
								/>
							</svg>
						</a>
						<a className={`${!link && "hidden"}`} href={link} target='__blank'>
							<ExternalLinkIcon className='inline-flex w-5 h-5 text-gray-400 hover:text-gray-500' />
						</a>
					</div>
				</div>
			</figure>

			<Modal
				project={{
					image,
					title,
					subtitle,
					description,
					link,
					gitlink,
					skills,
					roles,
					highlights,
					images,
				}}
				setShowModal={setShowModal}
				showModal={showModal}
			/>
		</React.Fragment>
	);
}

export default Project;

const splitter = (string, words = 40) => {
	const array = string.split(" ");
	if (array.length >= words) {
		return array.slice(0, words).join(" ") + "...";
	} else {
		return array.join(" ");
	}
};
